module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Black.woff2?e11ae7208ed88b29513e6f9652113d46";